var _ = require('lodash');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<!-- ko if: $component._btnGroupAdaptive --> <div class="btn-group-select"data-bind="template: {\n					nodes: $componentTemplateNodes,\n					data: $parent\n				},\n				css: btnGroup.css,\n				\'ko-component-btn-radio-group#clickListener\',\n				bsBtnGroupAdaptive: $component._btnGroupAdaptive,"></div><!-- /ko --><!-- ko ifnot: $component._btnGroupAdaptive --> <div class="btn-group-select btn-group"data-bind="template: {\n					nodes: $componentTemplateNodes,\n					data: $parent\n				},\n				css: btnGroup.css,\n				\'ko-component-btn-radio-group#clickListener\',"></div> <!-- /ko -->';
}
return __p;
};
